import $ from 'jquery';
import JQueryView from '../../../common/views/jqueryView';

export default class TopPageView extends JQueryView {
  constructor() {
    super('.user_guide');
    document.addEventListener('turbo:before-cache', function () {
      $('.js-slick.slick-initialized').slick('unslick');
    });

    const projectNum = $('.user_guide').find(
      '.top-project .c-projectItem',
    ).length;
    let projectInfinite;
    let projectCenterMode;
    let projectSlidesToShow;

    if (projectNum < 5) {
      $('.top-project .l-container').addClass('-item-4');
      projectInfinite = false;
      projectCenterMode = false;
      projectSlidesToShow = projectNum;
    } else {
      projectInfinite = true;
      projectCenterMode = false;
      projectSlidesToShow = 3;
    }

    $('.js-slick')
      .not('.slick-initialized')
      .slick({
        infinite: projectInfinite,
        autoplay: false,
        dots: false,
        slidesToShow: projectSlidesToShow,
        swipe: true,
        arrows: true,
        touchMove: false,
        variableWidth: true,
        centerMode: projectCenterMode,
        prevArrow: '<button class="slide-arrow slick-prev"></button>',
        nextArrow: '<button class="slide-arrow slick-next"></button>',
        responsive: [
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 3,
              swipe: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              swipe: true,
            },
          },
          {
            breakpoint: 1060,
            settings: {
              slidesToShow: 2,
              infinite: true,
              swipe: true,
            },
          },
          {
            breakpoint: 775,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              infinite: true,
              swipe: true,
            },
          },
        ],
      });
  }
}
